<template>
  <span class="rd-chip">
    <svg
      v-if="submitted"
      class="rd-chip-i"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 13l4 4 10-11"
        stroke="var(--color-energy-success)"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span v-else class="rd-diamond" aria-hidden="true" />
    <span class="rd-chip-name">{{ name }}</span>
    <span class="rd-chip-state" :class="{ 'rd-chip-state--ok': submitted }">{{ state }}</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  /** Display name, e.g. "You" or the opponent's name. */
  name: string;
  /** Human-readable status text, e.g. "typing..." / "Submitted". */
  state: string;
  /** Whether this player has submitted (checkmark vs. diamond). */
  submitted: boolean;
}>();
</script>

<style scoped>
.rd-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-sans);
  font-size: 13px;
  white-space: nowrap;
  /* Allow the chip to shrink within the status row so a long name truncates
     (below) rather than pushing the row past the screen edge on a narrow
     effective viewport (iOS Display Zoom). */
  min-width: 0;
}

.rd-chip-i {
  flex: 0 0 auto;
}

.rd-chip-name {
  font-weight: 700;
  color: var(--color-arena-text-bright);
  /* The name is the only variable-width part; let it absorb the shrink and
     ellipsis-truncate instead of forcing the chip wider than its container. */
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rd-chip-state {
  /* Keep the short status text intact; only the name truncates. */
  flex: 0 0 auto;
  color: var(--color-arena-text-muted);
}

.rd-chip-state--ok {
  color: var(--color-energy-success);
}

.rd-diamond {
  width: 9px;
  height: 9px;
  transform: rotate(45deg);
  border: 1.5px solid var(--color-arena-text-muted);
  display: inline-block;
}
</style>
